// Generated by purs version 0.15.0
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
var hrkToEurRate = 7.5345;
var hrkToEur = function ($1) {
    return Data_Money_Rounded.roundCents((function (v) {
        return v / hrkToEurRate;
    })(Data_Int.toNumber(Data_Money_Rounded.toCents($1))));
};
export {
    hrkToEurRate,
    hrkToEur
};
//# sourceMappingURL=index.js.map
